import { TextStyle } from '@coast/schemas';

export function getTextInputSize(textStyle: TextStyle): 'normal' | 'large' | 'xlarge' {
  switch (textStyle) {
    case 'h3':
      return 'xlarge';
    case 'h4':
      return 'large';
    case 'body1':
    case 'body1bold':
    default:
      return 'normal';
  }
}

const BOLD_TYPES: string[] = [
  'body1bold',
  'body2bold',
  'overlinebold',
  'caption1bold',
  'caption2bold',
];

export function isInputBold(textStyle: TextStyle): boolean {
  return BOLD_TYPES.includes(textStyle);
}
